import React from 'react';
import { Router as RouterBase } from 'react-router-dom';

export default function Router(props) {
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <RouterBase {...props} />;
}
